import { get, post, del, unwrapPage } from "./api_helper";

// Scheduled (future) SMS sends. Backed by the messaging service's
// sms/scheduled resource — see 02-sms-send.md. The bongasoft-messaging API
// exposes NO edit endpoint: a schedule can only be created (via bulk_list_helper
// → sendBulk), listed, viewed, or cancelled. "Edit" = cancel + recreate.

// GET /api/sms/scheduled?page=&size=&status= → Page<ScheduledSms>, newest first.
// `status` is optional; when set it must be one of the MessageStatus values.
export const getScheduledData = ({ page = 0, pageSize = 20, status } = {}) => {
  const params = new URLSearchParams({ page, size: pageSize });
  if (status) params.set("status", status);
  return get(`sms/scheduled?${params.toString()}`).then((res) => {
    const p = unwrapPage(res);
    const rows = p.rows.map((s) => ({
      id: s.id,
      shortcode: s.sender,
      message: s.message || "—",
      send_date_time: s.scheduledTime,
      // resolvedCount is set for FROZEN at schedule-time and for LIVE at
      // fire-time, so a PENDING LIVE row has none yet.
      send_count: s.resolvedCount ?? null,
      status: s.status,
      recipientResolution: s.recipientResolution,
      listIds: Array.isArray(s.listIds) ? s.listIds : [],
      msisdnList: s.msisdnList || "",
      processed: s.processed,
    }));
    return { rows, total: p.total, totalPages: p.pages, page: p.page };
  });
};

// GET /api/sms/scheduled/{id} → ScheduledSmsDetailResponse. Includes the current
// list-change (drift) summary — added/removed counts + per-list breakdown — which
// is non-null only once ≥1 drift event has been observed on a LIVE schedule.
export const getScheduledDetail = (id) => get(`sms/scheduled/${id}`);

// POST /api/sms/scheduled/{id}/freeze — lock a PENDING LIVE schedule's recipient
// set as-of-now (LIVE → FROZEN). 409 if the row is past PENDING; already-FROZEN
// rows return unchanged. → { scheduleId, recipientResolution, resolvedCount, resolvedAt }
export const freezeScheduledData = (id) => post(`sms/scheduled/${id}/freeze`);

// DELETE /api/sms/scheduled/{id} — cancel a PENDING schedule (409 if past PENDING).
export const cancelScheduledData = (id) => del(`sms/scheduled/${id}`);
